import { render } from "./RecoverModal.vue?vue&type=template&id=01bf8162"
import script from "./RecoverModal.vue?vue&type=script&lang=js"
export * from "./RecoverModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__